var render = function render(_c,_vm){return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('img',{staticClass:"d-none d-sm-flex",staticStyle:{"height":"56px"},attrs:{"src":require("@/assets/logo_text.png")}}),_c('img',{staticClass:"d-flex d-sm-none",staticStyle:{"height":"80%"},attrs:{"src":require("@/assets/logo.png")}})])
}
var staticRenderFns = []

export { render, staticRenderFns }